import { NAME } from './constants';

export const FETCH_ELEMENTS = `${NAME}/FETCH_ELEMENTS`;
export const FETCH_ELEMENTS_SUCCESS = `${NAME}/FETCH_ELEMENTS_SUCCESS`;
export const FETCH_ELEMENTS_FAILURE = `${NAME}/FETCH_ELEMENTS_FAILURE`;

export const FETCH_ELEMENT = `${NAME}/FETCH_ELEMENT`;
export const FETCH_ELEMENT_SUCCESS = `${NAME}/FETCH_ELEMENT_SUCCESS`;
export const FETCH_ELEMENT_FAILURE = `${NAME}/FETCH_ELEMENT_FAILURE`;

export const FETCH_ACCEPT_ELEMENTS = `${NAME}/FETCH_ACCEPT_ELEMENTS`;
export const FETCH_ACCEPT_ELEMENTS_SUCCESS = `${NAME}/FETCH_ACCEPT_ELEMENTS_SUCCESS`;
export const FETCH_ACCEPT_ELEMENTS_FAILURE = `${NAME}/FETCH_ACCEPT_ELEMENTS_FAILURE`;

export const FETCH_RECEIVE_ELEMENTS = `${NAME}/FETCH_RECEIVE_ELEMENTS`;
export const FETCH_RECEIVE_ELEMENTS_SUCCESS = `${NAME}/FETCH_RECEIVE_ELEMENTS_SUCCESS`;
export const FETCH_RECEIVE_ELEMENTS_FAILURE = `${NAME}/FETCH_RECEIVE_ELEMENTS_FAILURE`;

export const FETCH_UNCLAIM_ELEMENTS = `${NAME}/FETCH_UNCLAIM_ELEMENTS`;
export const FETCH_UNCLAIM_ELEMENTS_SUCCESS = `${NAME}/FETCH_UNCLAIM_ELEMENTS_SUCCESS`;
export const FETCH_UNCLAIM_ELEMENTS_FAILURE = `${NAME}/FETCH_UNCLAIM_ELEMENTS_FAILURE`;

export const FETCH_HISTORY_ELEMENTS = `${NAME}/FETCH_HISTORY_ELEMENTS`;
export const FETCH_HISTORY_ELEMENTS_SUCCESS = `${NAME}/FETCH_HISTORY_ELEMENTS_SUCCESS`;
export const FETCH_HISTORY_ELEMENTS_FAILURE = `${NAME}/FETCH_HISTORY_ELEMENTS_FAILURE`;

export const SAVE = `${NAME}/SAVE`;
export const SAVE_SUCCESS = `${NAME}/SAVE_SUCCESS`;
export const SAVE_FAILURE = `${NAME}/SAVE_FAILURE`;

export const DELETE_ELEMENT = `${NAME}/DELETE_ELEMENT`;
export const DELETE_ELEMENT_SUCCESS = `${NAME}/DELETE_ELEMENT_SUCCESS`;
export const DELETE_ELEMENT_FAILURE = `${NAME}/DELETE_ELEMENT_FAILURE`;

export const SAVE_ELEMENT = `${NAME}/SAVE_ELEMENT`;
export const SAVE_ELEMENT_SUCCESS = `${NAME}/SAVE_ELEMENT_SUCCESS`;
export const SAVE_ELEMENT_FAILURE = `${NAME}/SAVE_ELEMENT_FAILURE`;

export const FETCH_DATA = `${NAME}/FETCH_DATA`;
export const FETCH_DATA_SUCCESS = `${NAME}/FETCH_DATA_SUCCESS`;
export const FETCH_DATA_FAILURE = `${NAME}/FETCH_DATA_FAILURE`;

export const ACCEPT = `${NAME}/ACCEPT`;
export const ACCEPT_SUCCESS = `${NAME}/ACCEPT_SUCCESS`;
export const ACCEPT_FAILURE = `${NAME}/ACCEPT_FAILURE`;

export const RECEIVE = `${NAME}/RECEIVE`;
export const RECEIVE_SUCCESS = `${NAME}/RECEIVE_SUCCESS`;
export const RECEIVE_FAILURE = `${NAME}/RECEIVE_FAILURE`;

export const UPDATE_FORM_VALUE = `${NAME}/UPDATE_FORM_VALUE`;
export const SET_SORT = `${NAME}/SET_SORT`;
export const SET_ELEMENTS = `${NAME}/SET_ELEMENTS`;
export const SET_ACTIVE_ELEMENT = `${NAME}/SET_ACTIVE_ELEMENT`;
export const SET_ID_FOR_DELETE = `${NAME}/SET_ID_FOR_DELETE`;
export const SET_ID_TO_ACCEPT = `${NAME}/SET_ID_TO_ACCEPT`;
export const SET_ID_TO_RECEIVE = `${NAME}/SET_ID_TO_RECEIVE`;
export const RESET_FORM = `${NAME}/RESET_FORM`;
export const SET_FORM_ERRORS = `${NAME}/SET_FORM_ERRORS`;
export const SET_FORM_ERROR = `${NAME}/SET_FORM_ERROR`;
export const RESET_STATE = `${NAME}/RESET_STATE`;
export const CHANGE_FILTER = `${NAME}/CHANGE_FILTER`;
export const PROCESS_ELEMENTS = `${NAME}/PROCESS_ELEMENTS`;
export const PROCESS_ACCEPT_ELEMENTS = `${NAME}/PROCESS_ACCEPT_ELEMENTS`;
export const PROCESS_RECEIVE_ELEMENTS = `${NAME}/PROCESS_RECEIVE_ELEMENTS`;
export const PROCESS_UNCLAIM_ELEMENTS = `${NAME}/PROCESS_UNCLAIM_ELEMENTS`;
export const PROCESS_HISTORY_ELEMENTS = `${NAME}/PROCESS_HISTORY_ELEMENTS`;
export const ADD_NOTIFICATION = `${NAME}/ADD_NOTIFICATION`;
export const REMOVE_NOTIFICATION = `${NAME}/REMOVE_NOTIFICATION`;
export const SET_ACTIVE_PAGE = `${NAME}/SET_ACTIVE_PAGE`;
